import genericViewportDataSetMetadataProvider from '../../utilities/genericViewportDataSetMetadataProvider';
export function getGenericViewportRegisteredData(dataId) {
    return genericViewportDataSetMetadataProvider.get(genericViewportDataSetMetadataProvider.VIEWPORT_V2_DATA_SET, dataId);
}
export function getGenericViewportImageDataSet(dataId) {
    const registered = getGenericViewportRegisteredData(dataId);
    if (isStringArray(registered)) {
        return {
            imageIds: registered,
        };
    }
    if (!isGenericViewportImageDataSet(registered)) {
        return;
    }
    return registered;
}
export function getGenericViewportPlanarDataSet(dataId) {
    const registered = getGenericViewportRegisteredData(dataId);
    if (isStringArray(registered)) {
        return {
            imageIds: registered,
        };
    }
    if (!isGenericViewportImageDataSet(registered)) {
        return;
    }
    if ('kind' in registered && registered.kind && registered.kind !== 'planar') {
        return;
    }
    return registered;
}
export function getGenericViewportWSIDataSet(dataId) {
    const registered = getGenericViewportRegisteredData(dataId);
    if (isGenericViewportWSIDataSet(registered)) {
        return registered;
    }
    if (isRecord(registered) &&
        isStringArray(registered.imageIds) &&
        isRecord(registered.options) &&
        isWSIClientLike(registered.options.webClient)) {
        return {
            imageIds: registered.imageIds,
            kind: 'wsi',
            options: {
                miniNavigationOverlay: registered.options.miniNavigationOverlay,
                webClient: registered.options.webClient,
            },
        };
    }
}
export function getGenericViewportSourceDataId(dataId) {
    const registered = getGenericViewportRegisteredData(dataId);
    if (typeof registered === 'string') {
        return registered;
    }
    if (isStringArray(registered) && registered[0]) {
        return registered[0];
    }
    if (isGenericViewportSourceAliasDataSet(registered)) {
        return registered.sourceDataId;
    }
    return dataId;
}
export function isGenericViewportImageDataSet(value) {
    return isRecord(value) && isStringArray(value.imageIds);
}
export function isGenericViewportWSIDataSet(value) {
    return (isRecord(value) &&
        value.kind === 'wsi' &&
        isStringArray(value.imageIds) &&
        isRecord(value.options) &&
        isWSIClientLike(value.options.webClient));
}
export function isGenericViewportSourceAliasDataSet(value) {
    return (isRecord(value) &&
        (value.kind === 'video' || value.kind === 'ecg') &&
        typeof value.sourceDataId === 'string');
}
function isRecord(value) {
    return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}
function isStringArray(value) {
    return (Array.isArray(value) && value.every((item) => typeof item === 'string'));
}
function isWSIClientLike(value) {
    return isRecord(value) && typeof value.getDICOMwebMetadata === 'function';
}
